import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import DiscoverDetailsForm from '../../Containers/Discover/DiscoverDetailsFormContainer';
const localStyles = makeStyles(theme => ({
    button: {
        color: theme.palette.common.white,
        marginTop: theme.spacing(3),
        width: '75%',
    },
    card: {
        marginBottom: theme.spacing(3),
    },
    form: {},
    row: {
        display: 'flex',
    },
}));

const DiscoverDetails = () => {
    const classes = localStyles();
    return (
        <React.Fragment>
            <Grid item lg={12} md={12} xs={12}>
                <div>
                    <Card className={classes.card}>
                        <CardHeader title="Details" />
                        <CardContent>
                            <DiscoverDetailsForm />
                        </CardContent>
                    </Card>
                </div>
            </Grid>
        </React.Fragment>
    );
};
export default DiscoverDetails;
